module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/mv_photowedding_04-aaffa35b764c7272f7e29be514466636.webp";